// src/i18n/es/dashboard.js
const dashboard = {
    title: 'Panel de Control',
    subtitle: 'Sistema de Gestión de Taquillas',
    welcome: 'Bienvenido, %{name}',
    
    // Navigation and Tabs
    overview: 'General',
    performance: 'Rendimiento',
    efficiency: 'Eficiencia',
    
    // Period filters
    period: 'Período',
    today: 'Hoy',
    last_7_days: 'Últimos 7 Días',
    last_30_days: 'Últimos 30 Días',
    
    // Hotel selection
    select_hotel: 'Seleccionar Hotel',
    no_hotel_selected: 'Por favor selecciona un hotel para ver el dashboard',
    
    // Dashboard Summary
    available_lockers: 'Taquillas Disponibles',
    today_assignments: 'Asignaciones de Hoy',
    expired_active: 'Activas Vencidas',
    hmi_status: 'Estado HMI',
    of: 'de',
    total: 'total',
    pending_checkins: 'check-ins pendientes',
    require_attention: 'Requieren atención',
    online_devices: 'Dispositivos online',
    zone_availability: 'Disponibilidad por Zona',
    recent_assignments: 'Asignaciones Recientes',
    
    // Key Metrics
    key_metrics: 'Métricas Clave',
    occupancy_rate: 'Tasa de Ocupación',
    conversion_rate: 'Tasa de Conversión',
    avg_usage_hours: 'Tiempo Promedio de Uso',
    total_issues: 'Total de Problemas',
    
    // Charts
    usage_trends: 'Tendencias de Uso',
    assignments_created: 'Creadas',
    assignments_activated: 'Activadas',
    accesses: 'Accesos',
    zone_performance: 'Rendimiento por Zona',
    occupancy: 'Ocupación %',
    efficiency_percent: 'Eficiencia %',
    pending: 'Pendiente',
    
    // Assignment Efficiency
    assignment_efficiency: 'Eficiencia de Asignaciones',
    avg_time_to_use: 'Tiempo Promedio al Primer Uso',
    never_used: 'Nunca Usadas',
    most_requested_types: 'Tipos Más Solicitados',
    peak_demand_times: 'Horarios de Mayor Demanda',
    
    // Resources translations for dashboard components
    current_occupancy: 'Ocupación Actual',
    total_assignments: 'Total de Asignaciones',
    active_count: 'Cantidad Activa',
    avg_usage_time: 'Tiempo Promedio de Uso',
    per_assignment: 'Por Asignación',
    pending_to_active: 'Pendiente a Activa',
    issues: 'Problemas',
    avg_time_first_use: 'Tiempo Promedio al Primer Uso',
    never_used_assignments: 'Asignaciones Nunca Usadas',
    auto_archived_expired: 'Archivadas Automáticamente por Vencimiento',
    average_availability: 'Disponibilidad Promedio',
    weekly_usage_trend: 'Tendencia de Uso Semanal',
    occupancy_percent: 'Porcentaje de Ocupación',
    assignments_label: 'Etiqueta de Asignaciones',
    locker_status: 'Estado de Taquillas',
    system_health: 'Salud del Sistema',
    hmi_devices: 'Dispositivos HMI',
    devices_online: 'Dispositivos Conectados',
    blocked_lockers: 'Taquillas Bloqueadas',
    lockers_awaiting_clearance: 'Taquillas Esperando Liberación',
    expired_assignments: 'Asignaciones Vencidas',
    assignments_past_due: 'Asignaciones Vencidas',
    
    // System Info View translations
    system_information: 'Información del Sistema',
    loading_system_data: 'Cargando datos del sistema...',
    failed_load_system_info: 'Error al cargar la información del sistema',
    error_loading_system_info: 'Error al cargar la información del sistema',
    error_loading_background_jobs: 'Error al cargar tareas en segundo plano',
    job_triggered_successfully: 'Tarea ejecutada con éxito',
    error_triggering_job: 'Error al ejecutar la tarea',
    refresh_jobs: 'Actualizar Tareas',
    trigger_job_now: 'Ejecutar Tarea Ahora',
    no_background_jobs_found: 'No se encontraron tareas en segundo plano',
    
    // Application section
    application: 'Aplicación',
    version: 'Versión',
    environment: 'Entorno',
    uptime: 'Tiempo Activo',
    processors: 'Procesadores',
    machine: 'Máquina',
    
    // Database section  
    database: 'Base de Datos',
    status: 'Estado',
    size: 'Tamaño',
    provider: 'Proveedor',
    pending_migrations: 'Migraciones Pendientes',
    connected: 'Conectado',
    
    // Background Jobs section
    background_jobs: 'Tareas en Segundo Plano',
    job_name: 'Nombre de Tarea',
    queue: 'Cola',
    schedule: 'Programación',
    last_execution: 'Última Ejecución',
    next_execution: 'Próxima Ejecución',
    actions: 'Acciones',
    success: 'Éxito',
    succeeded: 'Exitoso',
    failed: 'Fallido',
    running: 'Ejecutándose',
    tabs: {
        overview: 'General',
        operational: 'Operacional',
        analytics: 'Análisis',
        reports: 'Reportes',
    },
    stats: {
        title: 'Estadísticas Rápidas',
        total_lockers: 'Total Taquillas',
        available_lockers: 'Disponibles',
        occupied_lockers: 'Ocupadas',
        maintenance_lockers: 'En Mantenimiento',
        occupancy_rate: 'Tasa de Ocupación',
        active_assignments: 'Asignaciones Activas',
        today_checkins: 'Check-ins Hoy',
        today_checkouts: 'Check-outs Hoy',
        alerts: 'Alertas Activas',
    },
    zones: {
        title: 'Disponibilidad por Zona',
        total: 'Total',
        available: 'Disponibles',
        occupied: 'Ocupadas',
        occupancy: 'Ocupación',
        no_zones: 'No hay zonas configuradas',
    },
    zone_schedules_title: 'Horarios de Zonas',
    zone_schedules_subtitle: 'Establezca los horarios de funcionamiento de cada zona',
    zone_schedules_no_zones: 'No hay zonas configuradas en este hotel.',
    recent: {
        title: 'Actividad Reciente',
        assignments: 'Asignaciones Recientes',
        releases: 'Liberaciones Recientes',
        maintenance: 'Mantenimientos Recientes',
        no_activity: 'No hay actividad reciente',
        view_all: 'Ver todo',
    },
    charts: {
        usage_trends: 'Tendencias de Uso',
        occupancy_chart: 'Ocupación por Hora',
        zone_performance: 'Rendimiento por Zona',
        locker_types: 'Distribución por Tipo',
        weekly_summary: 'Resumen Semanal',
        period: {
            today: 'Hoy',
            week: '7 días',
            month: '30 días',
            quarter: '90 días',
        },
    },
    quick_actions: {
        title: 'Acciones Rápidas',
        new_assignment: 'Nueva Asignación',
        find_locker: 'Buscar Taquilla',
        bulk_release: 'Liberación Masiva',
        maintenance_mode: 'Modo Mantenimiento',
        generate_report: 'Generar Reporte',
        scan_tag: 'Escanear Etiqueta',
    },
    alerts: {
        title: 'Alertas y Notificaciones',
        high_occupancy: 'Alta ocupación en %{zone}',
        maintenance_required: 'Mantenimiento requerido',
        low_availability: 'Baja disponibilidad de taquillas',
        system_alert: 'Alerta del sistema',
        no_alerts: 'No hay alertas activas',
        view_all: 'Ver todas las alertas',
    },
    efficiency_metrics: {
        title: 'Métricas de Eficiencia',
        avg_assignment_time: 'Tiempo Promedio de Asignación',
        avg_occupancy: 'Ocupación Promedio',
        turnover_rate: 'Tasa de Rotación',
        utilization_rate: 'Tasa de Utilización',
        peak_hours: 'Horas Pico',
        maintenance_rate: 'Tasa de Mantenimiento',
    },
    filters: {
        hotel: 'Hotel',
        all_hotels: 'Todos los hoteles',
        zone: 'Zona',
        all_zones: 'Todas las zonas',
        period: 'Período',
        apply: 'Aplicar',
        reset: 'Reiniciar',
    },
    messages: {
        loading: 'Cargando dashboard...',
        error: 'Error al cargar los datos',
        refresh_success: 'Datos actualizados',
        no_data: 'No hay datos disponibles',
        select_hotel: 'Seleccione un hotel',
        access_denied: 'No tienes permisos para ver el dashboard',
    },
    tooltips: {
        refresh: 'Actualizar datos',
        expand: 'Expandir',
        collapse: 'Contraer',
        info: 'Más información',
        download: 'Descargar datos',
    },
};

export default dashboard;